import { 
     IonButton, IonCardContent,
    useIonAlert, IonSegment, IonSegmentButton
  } from '@ionic/react';
import { Redirect, } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { updateUserSelectedInput, handleUserInput, handleRequestOtp } from "../services/actionHandlers"
import { GlobalStore } from "../../../store/GlobalStore";
import "../../../styles/UserSignInComponent.css";
function UserMobileOrEmailInput () {

    const {
        setUserLoginDetails
    }= GlobalStore()

    const [userDetail , setUserDetail] = useState({
        selectedInput : "mobile",
        newUser : false, 
        mobileNumber : "", 
        email : ""
    })

    const [redirectToVerification , setRedirectToVerification] = useState(false)

    const [present] = useIonAlert()
    useEffect(() => {
    }, [])

    return (
        <>
            <IonCardContent>
                <IonSegment value={userDetail.selectedInput} role="tablist" class="md">
                    <IonSegmentButton value="mobile" onClick={e => updateUserSelectedInput(e.target.value, userDetail,setUserDetail )} >Mobile</IonSegmentButton>
                    <IonSegmentButton value="email"  onClick={e => updateUserSelectedInput(e.target.value, userDetail,setUserDetail )} >Email</IonSegmentButton>
                </IonSegment>
                <div className='custom-label'>
                    <ion-label >{userDetail.selectedInput === 'mobile' ? "Mobile Number" : "Email"}</ion-label>
                    <input type="text"  className='custom-input' value={userDetail.selectedInput === 'mobile' ? userDetail.mobileNumber : userDetail.email } onChange={e=>handleUserInput(e.target.value,userDetail,setUserDetail)}/>
                </div>

                <IonButton color="primary" size="large" expand='block' mode='ios' onClick={async() => {
                    let response = await handleRequestOtp(userDetail, setUserDetail);
                    if (!response.status) {
                        present({
                            message: response.message,
                            buttons: [
                                    'Ok'
                            ],
                        })
                        return 
                    }
                    setUserLoginDetails(response.userDetails)
                    setRedirectToVerification(true)
                    }}>Request OTP</IonButton> {/*//href='/verify-login'*/}
                
                <a  href="/signup" className='link-btn' onClick={()=>{
                }}>Sign up</a> 
                { redirectToVerification &&
                    <Redirect to="/verification"/>
                }
                </IonCardContent>
        </>
    )
}

export default UserMobileOrEmailInput;